"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlmeApiSettingsBase = void 0;
const HttpHandlerSettingsBase_1 = require("../HttpHandlerSettingsBase");
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
const getApiHostname = () => {
    let globals;
    if (typeof window !== 'undefined') {
        globals = window;
    }
    else if (typeof self !== 'undefined') {
        globals = self;
    }
    else {
        return 'unknown';
    }
    return (globals && globals.location && globals.location.host) || 'unknown';
};
class AlmeApiSettingsBase extends HttpHandlerSettingsBase_1.HttpHandlerSettingsBase {
    constructor() {
        super();
        /**
         * Alme REST API protocol
         *
         * @default "https://"
         */
        this.AlmeApiProtocol = 'https://';
        /**
         * Alme REST API hostname.
         *
         * @example example.verint.com
         * @default globals.location.host | "unknown"
         */
        this.AlmeApiHostname = getApiHostname();
        /**
         * Alme REST API base path.  This path is combined with the specific request paths to create the request URI.
         *
         * @default "/AlmeAPI/api/"
         */
        this.AlmeApiBasePath = '/AlmeAPI/api/';
        /**
         * Alme REST API reporting event request endpoint path.
         *
         * @default "Conversation/ReportingEvent"
         */
        this.AlmeApiReportingEventPath = 'Conversation/ReportingEvent';
        /**
         * Alme REST API converse request endpoint path.
         *
         * @default "Conversation/Converse"
         */
        this.AlmeApiConverseEndpoint = 'Conversation/Converse';
        /**
         * Alme REST API application event request endpoint path.
         *
         * @default "Conversation/AppEvent"
         */
        this.AlmeApiAppEventEndpoint = 'Conversation/AppEvent';
        /**
         * Alme REST API request unit request endpoint path.
         *
         * @default "Conversation/RequestUnit"
         */
        this.AlmeApiRequestUnitEndpoint = 'Conversation/RequestUnit';
        /**
         * Alme REST API get history request endpoint path.
         *
         * @default "ConversationSupport/GetHistory"
         */
        this.AlmeApiGetHistoryEndpoint = 'ConversationSupport/GetHistory';
        /**
         * Alme REST API reporting event request endpoint path.
         *
         * @default "Conversation/ReportingEvent"
         */
        this.AlmeApiReportingEventEndpoint = 'Conversation/ReportingEvent';
        /**
         * Alme REST API get configuration request endpoint path.
         *
         * @default "Configuration/GetConfiguration"
         */
        this.AlmeApiConfigurationEndpoint = 'Configuration/GetConfiguration';
    }
}
exports.AlmeApiSettingsBase = AlmeApiSettingsBase;
//# sourceMappingURL=AlmeApiSettingsBase.js.map


// WEBPACK FOOTER //
// ../../Alme/AlmeApiSettingsBase.ts